module.exports = __webpack_public_path__ + "56bffc4776e70b60e4aeabe2c8c0f66e.svg";